// extracted by mini-css-extract-plugin
export var circle = "_ag-1";
export var exitConfirmationModal = "_ag-5";
export var iframe = "_ag-0";
export var offline = "_ag-3";
export var online = "_ag-2";
export var workstationSelectError = "_ag-4";